import React from 'react';
import * as PropTypes from 'prop-types';
import {
    Layout, Typography
} from 'antd';
import './Panels.css';
import {BannerImage} from "../image/BannerImage";
import {MainImage} from "../image/MainImage";
import {useScreenSizeBelow} from "../../utility/hooks/useScreenSize";

const { Text } = Typography;

const { Header, Footer, Sider, Content } = Layout;

const PanelFrameWithImage = ({ title, imageLocation, backgroundType, height, imageWidth, buttons, children }) => {

  // Height not enforced on narrowest screens
  if (useScreenSizeBelow(992)) {   //same as similar code in SummaryTabbedCanvas and matching image control in dp-panel-frame-image
      height = null;
  }

  // Variable Styling
  let titleColour = 'var(--dp-panel-text-colour)';
  if (backgroundType === 'filled') {
      titleColour = 'var(--dp-panel-text-filled-colour)';
  }
  let panelStyle = height ? { height: height } : {};
  let backgroundColor = 'var(--dp-panel-default-colour)';
  if (backgroundType === 'filled') {
      backgroundColor = 'var(--dp-panel-filled-colour)'
  } else if ((backgroundType === 'alternate')) {
      backgroundColor = 'var(--dp-panel-alternate-colour)'
  }
  panelStyle = { ...panelStyle, backgroundColor: backgroundColor};

  return (
    <Layout className="dp-panel-frame-outer">
        <Layout className="dp-panel-frame" style={panelStyle}>
                <Layout className="dp-panel-frame-left">
                    <Header className="dp-panel-frame-title">
                        <Text className="dp-panel-frame-title" style={{ color: titleColour }}>{title}</Text>
                    </Header>
                    <Content>
                        {children}
                    </Content>
                    <Footer className="dp-panel-frame-footer" >
                        {buttons ? buttons : <></>}
                    </Footer>
                </Layout>
                {/* Don't show image if null passed in, if image passed in, it will not show on narrower screens */}
                { imageLocation
                  ? <Sider className="dp-panel-frame-image" width={imageWidth}>
                        { height
                          ? <BannerImage imageSrc={imageLocation} height={height} />
                          : <MainImage imageSrc={imageLocation} /> }
                    </Sider>
                  : <></> }
        </Layout>
    </Layout>
  );
}

// Validate the prop type parameters.
PanelFrameWithImage.propTypes = {
  title: PropTypes.string.isRequired,
  imageLocation: PropTypes.string.isRequired,
  backgroundType: PropTypes.string,  //default or filled or alternate
  height: PropTypes.string,          // optional - will take allowed height if not set
  imageWidth: PropTypes.string,      // default is 180px if not passed in
  children: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)]).isRequired,
};

PanelFrameWithImage.defaultProps = {
    backgroundType: 'default',
    imageWidth: '170px',
};

export default PanelFrameWithImage;
